import { render, staticRenderFns } from "./ModalViewTipoUbicacion.vue?vue&type=template&id=04c76696&scoped=true&"
import script from "./ModalViewTipoUbicacion.vue?vue&type=script&lang=ts&"
export * from "./ModalViewTipoUbicacion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewTipoUbicacion.vue?vue&type=style&index=0&id=04c76696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c76696",
  null
  
)

export default component.exports